module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "finish-step"
  }, [(_vm.isPidListOrNPower) ? _c('upload-target-slot', {
    attrs: {
      "onComplete": _vm.finishOnComplete
    },
    on: {
      "submittedUploadFile": _vm.setOverrideBackButton
    }
  }) : (_vm.isAudienceDiscovery) ? _c('a-d-slot', {
    attrs: {
      "targetName": _vm.targetName,
      "onComplete": _vm.finishOnComplete,
      "title": _vm.title,
      "dataSourceIcon": _vm.dataSourceIcon
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-690b0f17"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/stepper/FinishStep.vue
// module id = 1929
// module chunks = 0